import { FC } from 'react';
import { RiderLocation } from '@rideiq/riders/features/RiderLocations/Location';

import { MustBeMetProtocolForm } from './MustBeMetProtocolForm';
import { Contact } from './types';

interface MustBeMetProtocolProps {
  mustBeMet: boolean | undefined;
  contacts: Contact[];
  accountLocationId?: string;
  placeId?: string;
  defaultValue?: RiderLocation | MustBeMetProtocol;
}

export const MustBeMetProtocol: FC<MustBeMetProtocolProps> = ({
  mustBeMet,
  contacts,
  accountLocationId,
  placeId,
  defaultValue,
}) => {
  if (mustBeMet) {
    return (
      <MustBeMetProtocolForm
        contacts={contacts}
        accountLocationId={accountLocationId}
        placeId={placeId}
        defaultValue={defaultValue}
      />
    );
  }

  return null;
};
